import * as socketIo from 'socket.io-client'
import MessageChannel from './message_channel'
export default class MessageChannelEmulator extends MessageChannel {
  constructor(options) {
    super(options)
    this.room = options.room
  }
  connect() {
    this.socket = socketIo.connect(this.options.url)
    if (this.room) {
      this.socket.on('connect', () => this.socket.emit('emulator-room', this.room))
    }
    this.socket.on('emulator', (message) => {
      /* tslint:disable */
      console.debug('accepted message', message)
      this.handle(message)
    })
    return new Promise((resolve, reject) => {
      this.socket.on('connect', () => resolve())
      this.socket.on('connect_error', (error) => reject(error))
    })
  }
  send(message) {
    /* tslint:disable */
    super.send(message)
    console.debug('send message', message)
    if (this.socket.connected) {
      if (this.room) {
        this.socket.emit('api', this.room, message)
      }
      else {
        this.socket.emit('api', message)
      }
    }
  }
}
